import { ReactComponent as CheckBoxIcon } from './check-box.svg'
export default CheckBoxIcon
